import React from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { AppText } from '../components/AppText';
import ErrorBoundary from '../components/errorBoundaries/ErrorBoundary';
import { SiteDetailsView } from '../components/map/SiteDetailsView';
import { useResolvedUserLocation } from '../components/map/useResolvedUserLocation';

const styles = StyleSheet.create({
  safeArea: { flex: 1 },
  container: { flex: 1, padding: 16 },
});

interface SiteDetailsScreenProps {
  route: { params: { siteId: string } };
}

function SiteDetailsScreen({ route }: SiteDetailsScreenProps) {
  const { siteId } = route.params;
  const registration = useSelector((state: any) => state.registration);
  const isLoggedIn = !!registration.user?.id;
  const navigation = useNavigation();
  // Reached directly (e.g. a deep link) rather than via SiteMapPantriesContent's map/list, which
  // already resolves this for its own search -- this screen has no other source for it.
  const { region } = useResolvedUserLocation(registration.user?.zip_code);

  return (
    <SafeAreaView style={styles.safeArea} edges={['top', 'left', 'right', 'bottom']}>
      <ErrorBoundary
        fallback={
          <View style={styles.container} testID="site-details-screen-error-fallback">
            <AppText>Unable to load site details.</AppText>
          </View>
        }
      >
        <SiteDetailsView
          siteId={siteId}
          isLoggedIn={isLoggedIn}
          onBack={() => navigation.goBack()}
          userCoordinate={region ?? undefined}
        />
      </ErrorBoundary>
    </SafeAreaView>
  );
}

export default SiteDetailsScreen;
